export default __webpack_public_path__ + "static/media/review.6d76dd3c.svg";